var ltv_controller_setup = function(
  $scope,
  chartFilters,
  service_api,
  method_name,
  chart_id
) {
  $scope.chart_id = chart_id;
  $scope.data = {};
  $scope.ranges = {};
  $scope.gradient_colors = [
    '#ecf8ff',
    '#E6F5FF',
    '#DBF0FF',
    '#D1ECFF',
    '#C7E8FF',
    '#BDE4FF',
    '#B3E0FF',
    '#A8DCFF',
    '#9ED8FF',
    '#94D4FF',
    '#8AD0FF',
    '#80CCFF',
    '#78c4ff'
  ];
  var service_method = service_api[method_name];
  var update_ltv_table = function (model) {
    service_method(model).then(function (resp) {
      $scope.data = resp;
      $scope.calculate_ranges();
    });
  };
  $scope.calculate_ranges = function () {
    var data_keys = Object.keys($scope.data[1] || $scope.data[0]);
    var ranges = {};
    for (var data_key of data_keys) {
      var values = $scope.data.map(row => row[data_key] || 0);
      ranges[data_key] = {
        min: Math.min.apply(Math, values),
        max: Math.max.apply(Math, values),
      };
    }
    $scope.ranges = ranges;
  };
  $scope.apply_color = function (value, key) {
    if (value != -1) {
      var { min, max } = $scope.ranges[key];
      if (min === max) {
        return undefined;
      }
      var value_coef = (value - min) / (max - min);
      var color = $scope.gradient_colors[
        Math.floor(value_coef * ($scope.gradient_colors.length - 1))
      ];
      return color;
    }
  };
  $scope.apply = function (value) {
    if (value == -1) {
      return '-';
    } else {
      return value;
    }
  };
  chartFilters.onChangeChartParams('do_' + method_name, update_ltv_table);
  update_ltv_table(chartFilters.get_chart_filters());
};


var ltv_controller_factory = function(method_name, chart_id) {
  return function($scope, chartFilters, service_api) {
    ltv_controller_setup($scope, chartFilters, service_api, method_name, chart_id);
  };
};


export {
  ltv_controller_setup,
  ltv_controller_factory,
}
